import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  text: {
    thank_you: 'Danke, {{name}}',
    confirmation_email:
      'Du erhältst bald eine Bestätigungs-E-Mail mit deiner Bestellnummer von unserem Technik-Partner {{provider_email}}',
    need_help: 'Hilfe oder Änderungen? Nur per Anruf',
  },
  labels: {
    order_number: 'Bestell Nr: {{number}}',
    order_number_short: '#{{number}}',
    today: 'Heute',
    was_prefix: 'war',
    restaurant: 'Restaurant',
    order_details: 'Bestell Info',
    your_details: 'Deine Angaben',
    contact: 'Kontakt',
    payment: 'Zahlung',
    payment_method: 'Zahlungsmethode',
    delivery: 'Lieferung',
    delivery_details: 'Lieferdetails',
    pickup_details: 'Abholdetails',
    pickup_instruction: '📋 Nenne uns deine Bestellnummer {{number}} bei der Abholung.',
    billing_info: 'Zahlungsinfo',
    order_summary: 'Bestellübersicht',
    help: 'Hilfe benötigt? Kontaktiere uns {{phone_number}}',
  },
  status: {
    canceled: 'Bestellung abgebrochen',
    received: 'Bestellung eingegangen',
    confirmed: 'Bestellung bestätigt!',
  },
  eta: {
    min_label: 'MIN',
  },
  order_methods: {
    [ORDER_METHODS.PICKUP]: 'Abholung',
    [ORDER_METHODS.DELIVERY]: 'Lieferung',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Zimmerservice',
      [RoomServiceLocationType.TableService]: 'Tischservice',
    },
  },
  room_service_details: {
    [RoomServiceLocationType.RoomService]: '(Zimmer #{{details}})',
    [RoomServiceLocationType.TableService]: '(Tisch #{{details}})',
  },
  rewards: {
    member: {
      pill_title: 'Punkte gesammelt',
      from_order: 'Punkte aus dieser Bestellung',
      total_balance: 'Gesamtstand',
      reward_value: 'Prämienwert',
      redeem_hint: '✓ Du kannst bis zu {{points}} Pkt. ({{amount}}) bei deiner nächsten Bestellung einlösen',
      points_to_redeem: 'Du brauchst nur noch {{points}} Punkte, um deine Prämie einzulösen',
    },
    guest: {
      pill_title: 'Prämien',
      earned_heading: 'Du hast <highlight>{{points}} Punkte</highlight> bei dieser Bestellung verdient',
      worth_on_next: 'Wert <strong>{{amount}}</strong> bei deiner nächsten Bestellung',
      ready_to_claim: 'Bereit zum Einlösen',
      next_order_discount: 'Rabatt bei der nächsten Bestellung',
      claim_cta: 'Löse deine {{points}} Pkt. ein — jetzt kostenlos registrieren',
      claim_note: 'Dauert 30 Sekunden · Punkte werden sofort gutgeschrieben',
    },
  },
  buttons: {
    back_to_menu: 'Zurück zum Menü',
    back_to_checkout: 'Zurück zur Kasse',
    contact_us: 'Kontaktiere uns {{phone_number}}',
    try_again: 'Erneut versuchen',
  },
  loading: {
    processing_payment: 'Bitte verlasse nicht die Seite, während wir deine Zahlung bearbeiten',
  },
  success_messages: {
    order_placed: {
      title: '✅ Bestellung erfolgreich!',
      description: 'Deine Bestellung wurde erfolgreich aufgegeben.',
    },
  },
  error_messages: {
    failed_to_load: 'Die Bestellung konnte nicht geladen werden. Bitte versuche es erneut.',
    payment_failed: 'Zahlung fehlgeschlagen, bitte versuche es erneut',
  },
  load_failed: {
    title: 'Deine Bestellung konnte nicht geladen werden',
    description:
      'Beim Laden deiner Bestelldetails ist etwas schiefgelaufen. Bitte versuche es erneut. Wenn es weiterhin nicht klappt, kontaktiere den Support, wir helfen dir sofort weiter.',
  },
};
